import React, { useCallback, useEffect, useState } from "react";
import WasteDisImg from "../../img/app/img1.jpeg";
import AvatarImg from "../../img/app/avatar_default_th.jpg";
import DefaultImage from "../../img/app/default-Image.webp";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { toScreen } from "../modules/Routing";
import {
  CDN,
  defaultAvatarImage,
  defaultMessagesFilter,
  imageFormat,
  jobImagesFolder,
  serverUrl,
  thumbSuffix,
  userImagesFolder,
} from "../config/GeneralConfig";
import {
  addJobNotes,
  driverPaymentDecision,
  getJobNotes,
  refundPaymentDecision,
} from "../modules/IssueAndResolution";
import { closeSpinner, modal, showSpinner, confirm } from "../modules/Dialogs";
import { toast } from "react-toastify";
// import { ChatIcon, CloseIcon, JobNotesIcon } from "./SvgIcon";

const getJobTypeDisplay = (jobType) => {
  const jobTypeMap = {
    getitems: "Get items",
    housemove: "House move",
    senditems: "Send items",
    wasteDisposal: "Waste Disposal",
  };
  return jobTypeMap[jobType] || jobType;
};

const DriverPayEligibility = ({
  onClose,
  selectedIssueResolution,
  conversationDetails,
  theCallBackFunc,
  userDetails,
  getConversations,
}) => {
  const [activeTab, setActiveTab] = useState("chat");
  const [notes, setNotes] = useState([]);
  const [noteInput, setNoteInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isAddingNote, setIsAddingNote] = useState(false);
  const [isDecisionMade, setIsDecisionMade] = useState(false);

  const navigate = useNavigate();

  const statusMap = React.useMemo(
    () => ({
      exempt: {
        label: "Waived",
        badge: "badge-secondary",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-off lucide-icon h-3 w-3"
          >
            <path d="m2 2 20 20"></path>
            <path d="M8.35 2.69A10 10 0 0 1 21.3 15.65"></path>
            <path d="M19.08 19.08A10 10 0 1 1 4.92 4.92"></path>
          </svg>
        ),
      },
      "not exempt": {
        label: "Applied",
        badge: "badge-danger",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-arrow-up lucide-icon h-3 w-3"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="m16 12-4-4-4 4"></path>
            <path d="M12 16V8"></path>
          </svg>
        ),
      },
      pending: {
        label: "Pending",
        badge: "badge-warning",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-clock h-3 w-3"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        ),
      },
      approved: {
        label: "Approved",
        badge: "badge-success",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-check h-3 w-3"
          >
            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
            <path d="m9 11 3 3L22 4"></path>
          </svg>
        ),
      },
      rejected: {
        label: "Rejected",
        badge: "badge-danger",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x h-3 w-3"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        ),
      },
    }),
    []
  );

  const jobStatus = React.useMemo(
    () => ({
      paid: {
        label: "Paid",
        badge: "badge-success",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-check-big lucide-icon h-3 w-3"
          >
            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
            <path d="m9 11 3 3L22 4"></path>
          </svg>
        ),
      },
      closed: {
        label: "Cancelled",
        badge: "badge-danger",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x h-3 w-3"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        ),
      },
    }),
    []
  );

  // Memoized computed values
  const status = selectedIssueResolution?.refund;
  const statusData = statusMap[status?.toLowerCase()];
  const jobDetailsStatus = selectedIssueResolution?.jobDetails?.status;
  const jobStatusData = jobStatus[jobDetailsStatus?.toLowerCase()];
  const INITIAL_NOTES = [];

  // Fixed refund payment decision function
  const handleDriverPaymentDecision = useCallback(
    async ({ jobId, verdict, quoteId }) => {
      const driverPaymentDecision_done = (
        resStatus,
        responseString,
        resJson
      ) => {
        closeSpinner();

        if (resStatus === 200) {
          modal("Driver Payment Decision has been resolved");
          if (theCallBackFunc) {
            theCallBackFunc();
          }
          if (onClose) {
            onClose();
          }
        } else if (resStatus === 400) {
          modal(responseString);
        } else {
          modal(responseString || "Something went wrong!");
        }
      };

      const payload = {
        jobId,
        verdict,
        quoteId,
      };

      try {
        driverPaymentDecision(
          payload,
          driverPaymentDecision_done,
          userDetails?.jwttoken
        );
      } catch (error) {
        closeSpinner();
        modal("Failed to process refund decision");
      }
    },
    [theCallBackFunc, onClose, userDetails?.jwttoken]
  );

  const handleGetJobNotes = useCallback(async () => {
    if (!selectedIssueResolution?.jobDetails?._id) {
      setNotes(INITIAL_NOTES);
      return;
    }

    setIsLoading(true);

    const getJobNotes_done = (resStatus, responseString, resJson) => {
      closeSpinner();
      setIsLoading(false);

      if (resStatus === 200) {
        setNotes(resJson?.notes || INITIAL_NOTES);
      } else {
        const errorMessage =
          resStatus === 400
            ? responseString
            : responseString || "Something went wrong!";
        modal(errorMessage);
        setNotes(INITIAL_NOTES);
      }
    };

    const queryParams = {
      noteType: "job",
      id: selectedIssueResolution?.jobDetails?._id,
    };

    try {
      getJobNotes(queryParams, getJobNotes_done, userDetails?.jwttoken);
    } catch (error) {
      closeSpinner();
      setIsLoading(false);
      modal("Failed to fetch job notes");
      setNotes(INITIAL_NOTES);
    }
  }, [selectedIssueResolution?.jobDetails?._id, userDetails?.jwttoken]);

  const handleAddJobNotes = useCallback(
    async ({ id, content, noteType }) => {
      const trimmedContent = content?.trim();
      if (trimmedContent) {
        const addJobNotes_done = (resStatus, responseString, resJson) => {
          setIsAddingNote(false);

          if (resStatus === 200) {
            toast.success("Note added successfully!");
            setNoteInput("");
            handleGetJobNotes();
          } else {
            // Revert optimistic update on failure
            setNotes(originalNotes);
            setNoteInput(originalNoteInput);
            const errorMessage =
              resStatus === 400
                ? responseString
                : responseString || "Something went wrong!";
            toast.error(errorMessage);
            modal(errorMessage);
          }
        };

        const payload = {
          id: selectedIssueResolution?.jobDetails?._id,
          content: trimmedContent,
          noteType: "job",
        };

        try {
          addJobNotes(payload, addJobNotes_done, userDetails?.jwttoken);
        } catch (error) {
          closeSpinner();
          setIsAddingNote(false);
          setNotes(originalNotes);
          setNoteInput(originalNoteInput);
          modal("Failed to add note");
        }
      }
    },
    [notes, noteInput, userDetails?.jwttoken, theCallBackFunc]
  );

  // Memoized avatar functions
  // const getDriverAvatarSrc = useCallback((selectedIssueResolution) => {
  //   if (
  //     selectedIssueResolution?.driverDetails?.avatar &&
  //     selectedIssueResolution?.driverDetails.avatar !== ""
  //   ) {
  //     return `${serverUrl}${userImagesFolder}/${selectedIssueResolution?.driverDetails?.shortId}/${selectedIssueResolution?.driverDetails?.avatar}${thumbSuffix}${imageFormat}`;
  //   }
  //   return `../img/${defaultAvatarImage}${imageFormat}`;
  // }, []);

  // const getClientAvatarSrc = useCallback((selectedIssueResolution) => {
  //   if (
  //     selectedIssueResolution?.clientDetails?.avatar &&
  //     selectedIssueResolution?.clientDetails.avatar !== ""
  //   ) {
  //     return `${serverUrl}${userImagesFolder}/${selectedIssueResolution?.clientDetails?.shortId}/${selectedIssueResolution?.clientDetails?.avatar}${thumbSuffix}${imageFormat}`;
  //   }
  //   return `../img/${defaultAvatarImage}${imageFormat}`;
  // }, []);

  // const getJobDetailsSrc = useCallback((shortId, image) => {
  //   if (image && shortId) {
  //     return `${serverUrl}${jobImagesFolder}/${shortId}/${image}${thumbSuffix}${imageFormat}`;
  //   }
  //   return DefaultImage;
  // }, []);

  useEffect(() => {
    setIsDecisionMade(false);
  }, [selectedIssueResolution]);

  // Render loading state
  if (isLoading && !selectedIssueResolution) {
    return (
      <div className="right-modal">
        <div className="modal-header">
          <div className="modal-title">
            <h2 className="font-semibold">Driver Pay Eligibility Review</h2>
            <button className="modal-close-btn" onClick={onClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-x h-5 w-5"
                aria-hidden="true"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
        </div>
        <div className="modal-body">
          <div className="text-center">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="right-modal">
      {/* Modal Header */}
      <div className="modal-header">
        <div className="modal-title">
          <h2 className="font-semibold">Driver Pay Eligibility Review</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-x h-5 w-5"
              aria-hidden="true"
            >
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Modal Body */}
      <div className="modal-body">
        {/* Job Details */}
        <div className="job-info">
          <div className="job-header">
            <div>
              <h3>
                <strong>Job Details</strong>
              </h3>
            </div>
            <button
              onClick={(e) =>
                toScreen(
                  e,
                  navigate,
                  "/job/" + selectedIssueResolution?.jobDetails?.shortId
                )
              }
              className="btn btn-secondary"
            >
              View Job Details
            </button>
          </div>
          {/* Job Images */}
          {selectedIssueResolution?.jobDetails?.images?.length > 0 && (
            <div className="job-images">
              {selectedIssueResolution.jobDetails.images.map((image, index) => (
                <div className="job-image" key={index}>
                  <img
                    src={`${CDN}/${selectedIssueResolution?.jobDetails?.images[index]}`}
                    alt={`Job image ${index + 1}`}
                    className="c-avatar__pic"
                    onError={(e) => {
                      e.target.src = DefaultImage;
                    }}
                  />
                </div>
              ))}
            </div>
          )}
          <div className="job-locations">
            <div>
              <span className="modal-label">Job Type</span>
              <span>
                {getJobTypeDisplay(
                  selectedIssueResolution?.jobDetails?.jobType
                )}
              </span>
            </div>
            <div className="job-info-col">
              <span className="job-info-label">Job Status</span>
              {jobStatusData && (
                <span
                  className={`badge d-inline-flex text-capitalize ${jobStatusData?.badge}`}
                >
                  {jobStatusData?.icon}
                  <span className="ml-1">{jobStatusData?.label}</span>
                </span>
              )}
            </div>
          </div>
          <div className="job-locations">
            <div>
              <span className="modal-label">Posted on</span>
              <span>
                {selectedIssueResolution?.jobDetails?.creationDate
                  ? moment(
                      selectedIssueResolution.jobDetails.creationDate
                    ).format("DD-MMM-YYYY, HH:mm")
                  : "-"}
              </span>
            </div>
            <div>
              <span className="modal-label">Scheduled for</span>
              <span>
                {selectedIssueResolution?.jobDetails?.scheduledFor
                  ? moment(
                      selectedIssueResolution.jobDetails.scheduledFor
                    ).format("DD-MMM-YYYY, HH:mm")
                  : "-"}
              </span>
            </div>
          </div>
          <div className="job-locations">
            <div>
              <span className="modal-label">Cancelled on</span>
              <span>
                {selectedIssueResolution?.cancellationDetails?.cancelledOn
                  ? moment(
                      selectedIssueResolution?.cancellationDetails?.cancelledOn
                    ).format("DD-MMM-YYYY, HH:mm")
                  : "-"}
              </span>
            </div>
          </div>
          {/* <div className="job-dates">
          </div> */}
          <div className="job-notes mb-0">
            <div className="note-item">
              <span className="text-gray-500 text-sm mb-4 d-block">
                Client cancellation reason
              </span>
              <div className=" text-capitalize">
                {selectedIssueResolution?.cancellationDetails?.reason}
              </div>
            </div>
          </div>
        </div>

        {/* Client & Driver Cards */}
        <div className="profiles">
          {/* Driver Profile */}
          <div className="profile-box">
            <strong>Driver</strong>
            <div className="profile">
              <img
                src={`${CDN}/${selectedIssueResolution?.driverDetails?.avatar}`}
                alt="Driver avatar"
                className="c-avatar__pic u-cursor-pointer"
                onError={(e) => {
                  e.target.src = AvatarImg;
                }}
              />
              <div className="text-capitalize">
                {`${
                  selectedIssueResolution?.driverDetails?.firstname
                    ? selectedIssueResolution.driverDetails.firstname
                    : ""
                } ${
                  selectedIssueResolution?.driverDetails?.lastname
                    ? selectedIssueResolution.driverDetails.lastname
                    : ""
                }`}

                <small>
                  ID: {selectedIssueResolution?.driverDetails?.shortId || "N/A"}
                </small>
              </div>
            </div>
            <div className="profile-actions">
              <button
                onClick={(e) =>
                  toScreen(
                    e,
                    navigate,
                    "/mav/" + selectedIssueResolution?.driverDetails?.shortId
                  )
                }
                disabled={!selectedIssueResolution?.driverDetails?.shortId}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Profile
              </button>
              <button
                className="c-btn c-btn--small c-btn--full-width c-btn--green"
                onClick={(e) =>
                  toScreen(
                    e,
                    navigate,
                    "/message/" +
                      selectedIssueResolution?.driverDetails?.shortId,
                    false,
                    {
                      receiverId: selectedIssueResolution?.driverDetails?._id,
                      receiverShortId:
                        selectedIssueResolution?.driverDetails?.shortId,
                      receiverType: "user",
                      userShortId1: "admin",
                      userShortId2:
                        selectedIssueResolution?.driverDetails?.shortId,
                      username2:
                        selectedIssueResolution?.driverDetails?.firstname,
                      selectedPage:
                        window.history.state?.usr?.selectedPage ?? 1,
                      selectedFilter:
                        window.history.state?.usr?.selectedFilter ??
                        defaultMessagesFilter,
                      previousPath:
                        window.history.state?.usr?.previousPath ??
                        window.location.pathname,
                    }
                  )
                }
                disabled={!selectedIssueResolution?.driverDetails?.shortId}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
                </svg>
                Chat
              </button>
            </div>
          </div>

          {/* Client Profile */}
          <div className="profile-box">
            <strong>Client</strong>
            <div className="profile">
              <img
                src={`${CDN}/${selectedIssueResolution?.userDetails?.avatar}`}
                alt="Client avatar"
                className="c-avatar__pic u-cursor-pointer"
                onError={(e) => {
                  e.target.src = AvatarImg;
                }}
              />
              <div className="text-capitalize">
                {`${
                  selectedIssueResolution?.userDetails?.firstname
                    ? selectedIssueResolution.userDetails.firstname
                    : ""
                } ${
                  selectedIssueResolution?.userDetails?.lastname
                    ? selectedIssueResolution.userDetails.lastname
                    : ""
                }`}
                <small>
                  ID: {selectedIssueResolution?.userDetails?.shortId || "N/A"}
                </small>
              </div>
            </div>
            <div className="profile-actions">
              <button
                onClick={(e) =>
                  toScreen(
                    e,
                    navigate,
                    "/client/" + selectedIssueResolution?.userDetails?.shortId
                  )
                }
                disabled={!selectedIssueResolution?.userDetails?.shortId}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Profile
              </button>
              <button
                className="c-btn c-btn--small c-btn--full-width c-btn--green"
                onClick={(e) =>
                  toScreen(
                    e,
                    navigate,
                    "/message/" + selectedIssueResolution?.userDetails?.shortId,
                    false,
                    {
                      receiverId: selectedIssueResolution?.userDetails?._id,
                      receiverShortId:
                        selectedIssueResolution?.userDetails?.shortId,
                      receiverType: "user",
                      userShortId1: "admin",
                      userShortId2:
                        selectedIssueResolution?.userDetails?.shortId,
                      username2:
                        selectedIssueResolution?.userDetails?.accountInfo
                          ?.username,
                      selectedPage:
                        window.history.state?.usr?.selectedPage ?? 1,
                      selectedFilter:
                        window.history.state?.usr?.selectedFilter ??
                        defaultMessagesFilter,
                      previousPath:
                        window.history.state?.usr?.previousPath ??
                        window.location.pathname,
                    }
                  )
                }
                disabled={!selectedIssueResolution?.userDetails?.shortId}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
                </svg>
                Chat
              </button>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="chat-tabs">
          <div
            className={`chat-tab${activeTab === "chat" ? " active" : ""}`}
            onClick={() => {
              setActiveTab("chat");
              getConversations(selectedIssueResolution);
            }}
            tabIndex={0}
            role="button"
            aria-pressed={activeTab === "chat"}
          >
          Client-Driver Conversation
          </div>
          <div
            className={`chat-tab${activeTab === "notes" ? " active" : ""}`}
            onClick={() => {
              setActiveTab("notes");
              handleGetJobNotes();
            }}
            tabIndex={0}
            role="button"
            aria-pressed={activeTab === "notes"}
          >
            Job Notes
          </div>
        </div>
        {/* Chat Tab */}
        {activeTab === "chat" && (
          <div className="chat-history">
            {conversationDetails?.messages?.length > 0 ? (
              conversationDetails?.messages?.map((messageDetails, index) => {
                const userType =
                  messageDetails?.userType === "mav" ? "driver" : "client";
                return (
                  <div key={index} className={`chat-message ${userType}`}>
                    <div class="text-sm mb-4 text-capitalize">{userType}</div>
                    <div className="text">{messageDetails?.message}</div>
                    <div className="meta">
                      {messageDetails?.time} ,{messageDetails?.date}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-danger text-normal">
                No conversation found.
              </p>
            )}
          </div>
        )}
        {/* Notes Tab */}
        {activeTab === "notes" && (
          <div className="job-notes">
            {notes?.length > 0 &&
              notes?.map((note, idx) => (
                <div className="note-item" key={idx}>
                  <div className="note-header">
                    <div className="author text-capitalize">{"Admin"}</div>
                    <div className="timestamp">
                      {" "}
                      {new Date(note?.createdAt).toLocaleString()}
                    </div>
                  </div>
                  <div className="note-body text-sm">{note?.content}</div>
                </div>
              ))}
            <div className="add-note">
              <label htmlFor="add-note-textarea">Add a note</label>
              <textarea
                id="add-note-textarea"
                placeholder="Type your note here..."
                value={noteInput}
                onChange={(e) => setNoteInput(e.target.value)}
                aria-label="Add note"
              ></textarea>
              <button
                className="btn add-btn"
                onClick={() =>
                  handleAddJobNotes({
                    id: selectedIssueResolution?._id,
                    noteType: "job",
                    content: noteInput,
                  })
                }
              >
                Add Note
              </button>
            </div>
          </div>
        )}
      </div>
      {/* Modal Footer */}
      <div className="modal-footer">
        <button className="btn btn-outline-primary" onClick={onClose}>
          Close
        </button>
        {selectedIssueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
          "pending" && (
          <div>
            <button
              className="btn btn-danger"
              style={{ marginRight: 12 }}
              onClick={() => {
                setIsDecisionMade(true);
                handleDriverPaymentDecision({
                  jobId: selectedIssueResolution?.jobDetails?._id,
                  verdict: "rejected",
                  quoteId: selectedIssueResolution?.jobDetails?.quoteId,
                });
              }}
            >
              Not Eligible
            </button>
            <button
              className="btn btn-success"
              onClick={() => {
                setIsDecisionMade(true);
                handleDriverPaymentDecision({
                  jobId: selectedIssueResolution?.jobDetails?._id,
                  verdict: "approved",
                  quoteId: selectedIssueResolution?.jobDetails?.quoteId,
                });
              }}
            >
              Gets paid
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DriverPayEligibility;
